const firebaseConfig = {
  apiKey: "AIzaSyB4tCNSCFrVIgJWqFeoB0PUycY7ThdibRM",
  authDomain: "renault-c2608.firebaseapp.com",
  databaseURL: "https://renault-c2608.firebaseio.com",
  projectId: "renault-c2608",
  storageBucket: "renault-c2608.appspot.com",
  messagingSenderId: "134532177926",
  appId: "1:134532177926:web:21b62ad537e5c9983ca387",
  measurementId: "G-B1R1CD7CQJ",
};

export default firebaseConfig;
